import React from 'react'

// components
import {
  CCol,
  CFormLabel,
  CFormCheck
} from '@coreui/react-pro'

const FormCheckboxInput = ({
  id,
  name,
  type,
  colSize,
  className,
  inputLabel,
  label,
  value,
  handleCheck,
  feedbackInvalid,
  invalid,
  disabled
}) => {
  return (
    <CCol lg={colSize} className={className}>
      {inputLabel && (
        <CFormLabel>
          {inputLabel}
        </CFormLabel>
      )}
      <CFormCheck
        id={id}
        name={name}
        type={type}
        label={label}
        defaultChecked={value}
        onChange={(e) => handleCheck(e)}
        feedbackInvalid={feedbackInvalid}
        invalid={invalid}
        disabled={disabled}
        checked={value}
      />
    </CCol>
  )
}

export default FormCheckboxInput